/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveAccountError extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;
    const errorResponse: Object = actionDrawerStore.errorResponse;
    return (
      <React.Fragment>
        <div styleName="action-drawer-content">
          <div>
            <h3>{t('general:trading_accounts.unarchive_failed')}</h3>
            <p>{actionDrawerStore.errorMessage}</p>
          </div>
          <div styleName="unarchive-account-details">
            {errorResponse && (
              <React.Fragment>
                <b>{t('general:trading_account')}</b>
                <ul>
                  {
                    <li>
                      {/* <b>{t('general:trading_account')}: </b> */}
                      {errorResponse.data.name}
                    </li>
                  }
                  {
                    <li>
                      {/* <b>{t('general:trading_accounts.labels.number')}: </b> */}
                      {errorResponse.data.account_no}
                    </li>
                  }
                </ul>
              </React.Fragment>
            )}
          </div>
        </div>
        <div styleName="action-drawer-actions">
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
